import { Modifier, SelectionState } from 'draft-js';

export {
  VARIABLE_LINE_STYLES,
  DEFAULT_VARIABLE_LINE_STYLE,
  formatVariableSeparator,
  applyVariableLineStyle,
} from '../shared/variables/variableLineStyle';

// Emplacements d'une entité variable dans un contenu, avec sa data. Une entité
// n'existe que dans le contenu qui l'a créée : la recherche est bornée à la box
// qui porte l'occurrence. Plusieurs plages quand le texte a été copié-collé
// dans la même box (Draft réutilise alors la même entité).
export const findVariableEntityRanges = (editorState, entityKey) => {
  if (!editorState || !entityKey) return null;
  const content = editorState.getCurrentContent();

  let entity;
  try {
    entity = content.getEntity(entityKey);
  } catch (e) {
    // Entité disparue de l'entityMap (variable supprimée, contenu remplacé).
    return null;
  }
  if (!entity || entity.getType() !== 'VARIABLE') return null;

  const ranges = [];
  content.getBlocksAsArray().forEach((block) => {
    block.findEntityRanges(
      (character) => character.getEntity() === entityKey,
      (start, end) => {
        ranges.push({ blockKey: block.getKey(), start, end });
      }
    );
  });
  if (ranges.length === 0) return null;

  return { ranges, data: entity.getData() ?? {} };
};

// Première plage + data, pour lire l'état courant d'une occurrence.
export const findVariableEntityRange = (editorState, entityKey) => {
  const found = findVariableEntityRanges(editorState, entityKey);
  if (!found) return null;

  return { ...found.ranges[0], data: found.data };
};

// Réécrit le texte d'une occurrence et mémorise son style de ligne et son
// séparateur sur l'entité. Retourne le nouveau ContentState, ou null si
// l'occurrence a disparu du contenu entre-temps.
export const replaceVariableOccurrence = ({ editorState, entityKey, text, lineStyle, separator }) => {
  const found = findVariableEntityRanges(editorState, entityKey);
  if (!found || typeof text !== 'string') return null;

  const data = { ...found.data, lineStyle, separator };
  // Pas de clé vide dans le contenu enregistré : absent = espace.
  if (!separator) delete data.separator;

  let content = editorState.getCurrentContent().replaceEntityData(entityKey, data);

  // Plages traitées de la dernière à la première : réécrire une plage décale
  // celles qui la suivent dans le même bloc.
  found.ranges
    .slice()
    .reverse()
    .forEach(({ blockKey, start, end }) => {
      content = Modifier.replaceText(
        content,
        SelectionState.createEmpty(blockKey).merge({
          anchorOffset: start,
          focusOffset: end,
        }),
        text,
        content.getBlockForKey(blockKey).getInlineStyleAt(start),
        entityKey
      );
    });

  return content;
};
